import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function Calendar({ bookings, selectedDate, onSelectDate }) {
  const [cursor, setCursor] = useState(() => { const d = new Date(); return { y: d.getFullYear(), m: d.getMonth() }; });

  // confirmed booking counts per date
  const counts = {};
  bookings.filter((b) => b.status === "confirmed").forEach((b) => {
    counts[b.date] = (counts[b.date] || 0) + 1;
  });

  const first = new Date(cursor.y, cursor.m, 1);
  const startOffset = (first.getDay() + 6) % 7; // Mon=0
  const daysInMonth = new Date(cursor.y, cursor.m + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const fmt = (d) => `${cursor.y}-${String(cursor.m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const move = (delta) => setCursor((c) => {
    const nm = c.m + delta;
    return { y: c.y + Math.floor(nm / 12), m: ((nm % 12) + 12) % 12 };
  });
  const todayStr = new Date().toISOString().split("T")[0];

  return (
    <div className="border-2 border-foreground rounded-xl overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b-2 border-foreground bg-muted">
        <button data-testid="cal-prev" onClick={() => move(-1)} className="p-1.5 border-2 border-foreground rounded-md hover:bg-background"><ChevronLeft size={16} /></button>
        <span className="font-head font-bold">{MONTHS[cursor.m]} {cursor.y}</span>
        <button data-testid="cal-next" onClick={() => move(1)} className="p-1.5 border-2 border-foreground rounded-md hover:bg-background"><ChevronRight size={16} /></button>
      </div>
      <div className="grid grid-cols-7 text-center font-mono-plex text-[10px] uppercase tracking-wider bg-foreground text-background">
        {DOW.map((d) => <div key={d} className="py-1.5">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {cells.map((d, i) => {
          if (!d) return <div key={`empty-${i}`} className="aspect-square border-b border-r border-foreground/10 bg-muted/40" />;
          const ds = fmt(d);
          const cnt = counts[ds] || 0;
          const isSel = selectedDate === ds;
          const isToday = todayStr === ds;
          return (
            <button
              key={ds}
              data-testid={`cal-day-${ds}`}
              onClick={() => onSelectDate(isSel ? null : ds)}
              className={`aspect-square border-b border-r border-foreground/10 flex flex-col items-center justify-center gap-1 text-sm transition-colors ${
                isSel ? "bg-primary" : "hover:bg-secondary/15"
              } ${isToday ? "font-extrabold" : ""}`}
            >
              <span className={isToday ? "underline decoration-secondary decoration-2" : ""}>{d}</span>
              {cnt > 0 && <span className="w-5 h-5 rounded-full bg-secondary text-secondary-foreground text-[10px] font-mono-plex flex items-center justify-center">{cnt}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
